import PDFStream from '../../core/objects/PDFStream.js';
import { arrayAsString } from '../../utils/index.js';
class PDFRawStream extends PDFStream {
    static of = (dict, contents) => new PDFRawStream(dict, contents);
    contents;
    constructor(dict, contents) {
        super(dict);
        this.contents = contents;
    }
    asUint8Array() {
        return this.contents.slice();
    }
    clone(context) {
        return PDFRawStream.of(this.dict.clone(context), this.contents.slice());
    }
    getContentsString() {
        return arrayAsString(this.contents);
    }
    getContents() {
        return this.contents;
    }
    getContentsSize() {
        return this.contents.length;
    }
}
export default PDFRawStream;
//# sourceMappingURL=PDFRawStream.js.map